
      // Hide splash screen when app is loaded
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          const splashScreen = document.getElementById('splash-screen');
          if (splashScreen) {
            splashScreen.style.opacity = '0';
            splashScreen.style.transition = 'opacity 0.3s ease';
            setTimeout(() => {
              splashScreen.style.display = 'none';
            }, 300);
          }
        }, 1000);

        // Enable dark mode based on system preference
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      });
    